import useMediaQuery from '@mui/material/useMediaQuery';

import { theme } from '../styles';

export const useIsMobile = (): boolean => {
  return useMediaQuery(theme.breakpoints.down('sm'));
};
